import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";
const ourValues = [
  {
    title: "Bewegung",
    description: "Entdecke den Spaß an der Bewegung oder finde sie wieder.",
    icon: "icon-move",
    animation: "firstValue"
  },
  {
    title: "Anker",
    description: "Den inneren Anker finden.",
    icon: "icon-care"
  },
  {
    title: "Körper und Geist",
    description: "Über seinen eigenen Körper und Geist bewusst werden.",
    icon: "icon-yin-yang"
  },
  {
    title: "Innere Ruhe",
    description: "Finde die innere Ruhe.",
    icon: "icon-yoga"
  }
];

const ValuesSection = () => (
  <ScrollableAnchor id="values">
    <section className="values content-section bg-primary text-white text-center">
      <div className="container">
        <div className="content-section-heading">
          <h3 className="text-secondary mb-0">Werte</h3>
          <h2 className="mb-5">Unsere Werte</h2>
        </div>
        <div className="row animatedParent animateOnce" data-appear-top-offset='-300' data-sequence='1000'>
          {ourValues.map((service, index) => (
            <div className="col-lg-3 col-md-6 mb-5 mb-lg-0 animated bounceIn" key={`service_${index}`} data-id={index+1}>
              <div className="service-icon rounded-circle mx-auto mb-3 center" >
                <i className={service.icon} />
              </div>
              <h4>
                <strong>{service.title}</strong>
              </h4>
              <p className="text-faded mb-0">{service.description}</p>
            </div>
          ))}
        </div>
          <a className="btn btn-light btn-xl js-scroll-trigger margin-top" href="#possibilities">Deine Möglichkeiten</a>
      </div>
    </section>
  </ScrollableAnchor>
);
export default ValuesSection;



// WEBPACK FOOTER //
// ./src/main/values.js